export default __webpack_public_path__ + "static/media/Error401.6545979c.svg";